import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import FormAction from "./formAction";

const DMIN_ID = 48;

function AcademicInfo(props) {
  const [state, setState] = useState({
    formData: {
      percent_completed: 35,
      intended_enrollment_date: "",
      intended_term: "",
      leading_source: [0, 0, 0, 0, 0, 0, 0, 0, 0],
      "leading_source[0]": "",
      "leading_source[1]": "",
      "leading_source[2]": "",
      "leading_source[3]": "",
      "leading_source[4]": "",
      "leading_source[5]": "",
      "leading_source[6]": "",
      "leading_source[7]": "",
      "leading_source[8]": "",
    },
    intended_enrollment_dateValid: "",
    intended_termValid: "",
    isFormDataValid: false,
  });

  const { savedSteps, selectedProgramId, selectedProgramLabel } = useSelector(
    (state) => ({
      savedSteps: state.applicationReducer.savedSteps,
      selectedProgramId: state.applicationReducer.selectedProgramId,
      selectedProgramLabel: state.applicationReducer.selectedProgramLabel,
    }),
    shallowEqual
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!!savedSteps.academicInfo) {
      populateForm();
    }
  }, []);

  useEffect(() => {
    validateForm();
  }, [state]);

  function populateForm() {
    const academicInfoData = savedSteps.academicInfo;
    if (!!savedSteps.academicInfo && Object.keys(academicInfoData).length > 0) {
      let leadSourceArr = academicInfoData?.leading_source
        ?.toString()
        ?.split(",");
      updateForm(
        "intended_enrollment_date",
        academicInfoData.intended_enrollment_date
      );
      updateForm("intended_term", academicInfoData.intended_term);
      updateForm("leading_source", leadSourceArr);
      updateForm("leading_source[0]", leadSourceArr[0]);
      updateForm("leading_source[1]", leadSourceArr[1]);
      updateForm("leading_source[2]", leadSourceArr[2]);
      updateForm("leading_source[3]", leadSourceArr[3]);
      updateForm("leading_source[4]", leadSourceArr[4]);
      updateForm("leading_source[5]", leadSourceArr[5]);
      updateForm("leading_source[6]", leadSourceArr[6]);
      updateForm("leading_source[7]", leadSourceArr[7]);
      updateForm("leading_source[8]", leadSourceArr[8]);
    }
  }

  const updateForm = (field, value) => {
    let temp = state.formData;
    switch (field) {
      case "leading_source[0]":
        temp.leading_source[0] = value;
        temp[field] = value;
        break;
      case "leading_source[1]":
        temp.leading_source[1] = value;
        temp[field] = value;
        break;
      case "leading_source[2]":
        temp.leading_source[2] = value;
        temp[field] = value;
        break;
      case "leading_source[3]":
        temp.leading_source[3] = value;
        temp[field] = value;
        break;
      case "leading_source[4]":
        temp.leading_source[4] = value;
        temp[field] = value;
        break;
      case "leading_source[5]":
        temp.leading_source[5] = value;
        temp[field] = value;
        break;
      case "leading_source[6]":
        temp.leading_source[6] = value;
        temp[field] = value;
        break;
      case "leading_source[7]":
        temp.leading_source[7] = value;
        temp[field] = value;
        break;
      case "leading_source[8]":
        temp.leading_source[8] = value;
        temp[field] = value;
        break;
      default:
        temp[field] = value;
        break;
    }
    setState((prevState) => ({ ...prevState, formData: temp }));
    _validate(field);
  };
  const _validate = (field) => {
    let regex, valid;
    let value = state.formData[field];
    switch (field) {
      case "leading_source[0]":
      case "leading_source[1]":
      case "leading_source[2]":
      case "leading_source[3]":
      case "leading_source[4]":
      case "leading_source[5]":
      case "leading_source[6]":
      case "leading_source[7]":
      case "leading_source[8]":
        valid = true;
        break;
      case "intended_enrollment_date":
      case "intended_term":
        regex = /^.{1,}/;
        valid = regex.test(value);
        break;
    }
    setState((prevState) => ({ ...prevState, [field + "Valid"]: valid }));
  };

  const validateForm = () => {
    let formData = state;
    let form = !!formData.intended_enrollment_dateValid;
    if (state.isFormDataValid != form) {
      setState((prevState) => ({ ...prevState, isFormDataValid: form }));
    }
  };

  return (
    <>
      <div className="app-form-container demographic residency">
        <div className="main-heading bayan-main-heading">
          {selectedProgramLabel}
        </div>
        <div className="sub-heading app-info">Academic Information</div>
        <div className="form-content">
          <div className="input-group">
            <div className="field-label">
              Academic Date* - When do you intend to enroll?
            </div>
            <select
              placeholder="Select a term"
              value={state.formData.intended_enrollment_date}
              onChange={(e) => {
                updateForm("intended_enrollment_date", e.target.value);
              }}
            >
              <option disabled value="">
                Select a term
              </option>
              <option value={"Fall 2024"}>Fall 2024</option>
              {selectedProgramId !== DMIN_ID && (
                <option value={"Spring 2025"}>Spring 2025</option>
              )}
              {selectedProgramId !== DMIN_ID && (
                <option value={"Summer 2025"}>Summer 2025</option>
              )}
              <option value={"Fall 2025"}>Fall 2025</option>
            </select>
          </div>

          {/*<div className="input-group">
              <div className="field-label">How do you intend to study?*</div>
              <select placeholder="Select a term" value={state.formData.intended_term} onChange={(e)=>{updateForm('intended_term', e.target.value)}}>
                <option value=''>Select a term</option>
                <option value={1}>Online</option>
                <option value={2}>Face-to-Face</option> */}
          {/* <option value={3}>Hybrid</option>
              </select>
             </div>*/}

          <div className="input-group">
            <div className="field-label">
              Select the source that led you to us? - Select all that apply
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[0]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[0]",
                      state.formData["leading_source[0]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[0]",
                      state.formData["leading_source[0]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Social Media (Facebook, Instagram, Twitter)
                </div>
              </div>
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[1]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[1]",
                      state.formData["leading_source[1]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[1]",
                      state.formData["leading_source[1]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Graduate School Fair
                </div>
              </div>
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[2]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[2]",
                      state.formData["leading_source[2]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[2]",
                      state.formData["leading_source[2]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Conference
                </div>
              </div>
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[3]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[3]",
                      state.formData["leading_source[3]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[3]",
                      state.formData["leading_source[3]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Religious Affiliation
                </div>
              </div>
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[4]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[4]",
                      state.formData["leading_source[4]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[4]",
                      state.formData["leading_source[4]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Bayan Event
                </div>
              </div>
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[5]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[5]",
                      state.formData["leading_source[5]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[5]",
                      state.formData["leading_source[5]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Bayan Faculty/Staff/Alum
                </div>
              </div>
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[6]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[6]",
                      state.formData["leading_source[6]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[6]",
                      state.formData["leading_source[6]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Current Bayan Student
                </div>
              </div>
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[7]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[7]",
                      state.formData["leading_source[7]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[7]",
                      state.formData["leading_source[7]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Online Advertisement
                </div>
              </div>
            </div>

            <div className="inline-radio">
              <div className={`radio-options`}>
                <div
                  className={`radio-button ${
                    state.formData["leading_source[8]"] == 1 ? "selected" : ""
                  }`}
                  onClick={() => {
                    updateForm(
                      "leading_source[8]",
                      state.formData["leading_source[8]"] === 1 ? 0 : 1
                    );
                  }}
                ></div>
                <div
                  className={`radio-label`}
                  onClick={() => {
                    updateForm(
                      "leading_source[8]",
                      state.formData["leading_source[8]"] === 1 ? 0 : 1
                    );
                  }}
                >
                  Internet Search
                </div>
              </div>
            </div>
          </div>
        </div>
        <FormAction
          isFormDataValid={state.isFormDataValid}
          formData={state.formData}
          formStep={"academicInfo"}
          backStep={"demographics"}
          nextStep={"educationalHistory"}
        />
      </div>
    </>
  );
}

// const mapStateToProps = state => ({
//   savedSteps: state.application.savedSteps,
//   reqForm: state.user.data,
// })

export default AcademicInfo;
